import { helpText, Theme } from 'features/Theme';
import { css, SerializedStyles } from '@emotion/core';

const styles = {
  container: (theme: Theme): SerializedStyles => css`
    margin-left: ${theme.mui.spacing(2)}px;
  `,
  studentApplicationText: (theme: Theme): SerializedStyles => css`
    &,
    p {
      ${helpText(theme)};
      text-align: left;
    }
  `,
  studentApplicationLabel: (theme: Theme): SerializedStyles => css`
    .MuiFormControlLabel-label {
      ${helpText(theme)};
    }
  `,
};
export default styles;
